import Input from './Input';

export default {
  variants: {
    ...Input.variants,
  },
  defaultProps: {
    ...Input.defaultProps,
  },
};
